import { put } from 'redux-saga/effects';
import TagTypessActions from '../redux/TagTypesRedux';
import i18n from '../i18n';

export function* getTagTypes(api, { customerId, pageParams }) {
  try {
    const getTagTypesResponse = yield api.getTagTypes(customerId, pageParams);
    // console.log('getTagTypesResponse:', getTagTypesResponse);
    if (getTagTypesResponse.ok) {
      yield put(
        TagTypessActions.getTagTypesRequestSuccess(
          getTagTypesResponse.data.content,
          getTagTypesResponse.data.totalElements
        )
      );
    } else {
      api.checkAuth(getTagTypesResponse);
      let error = i18n.t('unexpectedError');
      let errorBody =
        typeof getTagTypesResponse.problem !== 'undefined'
          ? getTagTypesResponse.problem
          : typeof getTagTypesResponse.data.error !== 'undefined'
          ? getTagTypesResponse.data.error
          : null;
      if (errorBody) {
        error += `: ${errorBody}`;
      }
      yield put(TagTypessActions.getTagTypesRequestFailure(error));
    }
  } catch (error) {
    console.log('error in tags saga', error);
    yield put(TagTypessActions.getTagTypesRequestFailure(error));
  }
}

export function* createTagType(api, { tagTypeInfos, customerId, pageParams }) {
  try {
    const createTagTypeResponse = yield api.createTagType(tagTypeInfos);
    console.log('createTagTypeResponse:', createTagTypeResponse);
    const getTagTypesResponse = yield api.getTagTypes(customerId, pageParams);
    console.log('getTagTypesResponse:', getTagTypesResponse);
    const successMessage = i18n.t('successMessage.createTagType');

    if (createTagTypeResponse.ok && getTagTypesResponse.ok) {
      yield put(
        TagTypessActions.createTagTypeRequestSuccess(
          createTagTypeResponse.data.tagTypeId,
          getTagTypesResponse.data.content,
          getTagTypesResponse.data.totalElements,
          successMessage
        )
      );
    } else {
      api.checkAuth(createTagTypeResponse);
      api.checkAuth(getTagTypesResponse);
      let error = i18n.t('unexpectedError');
      let errorBody =
        typeof createTagTypeResponse.problem !== 'undefined'
          ? createTagTypeResponse.problem
          : typeof createTagTypeResponse.data.error !== 'undefined'
          ? createTagTypeResponse.data.error
          : null;
      if (errorBody) {
        error += `: ${errorBody}`;
      }
      yield put(TagTypessActions.createTagTypeRequestFailure(error));
    }
  } catch (error) {
    console.log('error in tags saga', error);
    yield put(TagTypessActions.createTagTypeRequestFailure(error));
  }
}

export function* editTagType(api, { tagTypeInfos, customerId, pageParams }) {
  try {
    const editTagTypeResponse = yield api.editTagType(tagTypeInfos);
    console.log('editTagTypeResponse:', editTagTypeResponse);
    const getTagTypesResponse = yield api.getTagTypes(customerId, pageParams);
    console.log('getTagTypesResponse:', getTagTypesResponse);
    const successMessage = i18n.t('successMessage.editTagType');

    if (editTagTypeResponse.ok && getTagTypesResponse.ok) {
      yield put(
        TagTypessActions.editTagTypeRequestSuccess(
          getTagTypesResponse.data.content,
          getTagTypesResponse.data.totalElements,
          successMessage
        )
      );
    } else {
      api.checkAuth(editTagTypeResponse);
      api.checkAuth(getTagTypesResponse);
      let error = i18n.t('unexpectedError');
      let errorBody =
        typeof editTagTypeResponse.problem !== 'undefined'
          ? editTagTypeResponse.problem
          : typeof editTagTypeResponse.data.error !== 'undefined'
          ? editTagTypeResponse.data.error
          : null;
      if (errorBody) {
        error += `: ${errorBody}`;
      }
      yield put(TagTypessActions.editTagTypeRequestFailure(error));
    }
  } catch (error) {
    console.log('error in tags saga', error);
    yield put(TagTypessActions.editTagTypeRequestFailure(error));
  }
}

export function* deleteTagType(api, { tagTypeId, customerId, pageParams }) {
  try {
    const deleteTagTypeResponse = yield api.deleteTagType(tagTypeId);
    console.log('deleteTagTypeResponse:', deleteTagTypeResponse);
    const getTagTypesResponse = yield api.getTagTypes(customerId, pageParams);
    console.log('getTagTypesResponse:', getTagTypesResponse);
    const successMessage = i18n.t('successMessage.deleteTagType');
    console.log('successMessage:', successMessage);

    if (deleteTagTypeResponse.ok && getTagTypesResponse.ok) {
      yield put(
        TagTypessActions.deleteTagTypeRequestSuccess(
          getTagTypesResponse.data.content,
          getTagTypesResponse.data.totalElements,
          successMessage
        )
      );
    } else {
      api.checkAuth(deleteTagTypeResponse);
      api.checkAuth(getTagTypesResponse);
      let error = i18n.t('unexpectedError');
      let errorBody =
        typeof deleteTagTypeResponse.problem !== 'undefined'
          ? deleteTagTypeResponse.problem
          : typeof deleteTagTypeResponse.data.error !== 'undefined'
          ? deleteTagTypeResponse.data.error
          : null;
      if (errorBody) {
        error += `: ${errorBody}`;
      }
      yield put(TagTypessActions.deleteTagTypeRequestFailure(error));
    }
  } catch (error) {
    console.log('error in tags saga', error);
    yield put(TagTypessActions.deleteTagTypeRequestFailure(error));
  }
}
